export function suggestLineCode(existingLines: { code: string }[]): string {
  const re = /^LINHA-(\d+)$/;
  const numbers = existingLines
    .map((l) => re.exec(l.code)?.[1])
    .filter((s): s is string => !!s)
    .map(Number);
  const next = numbers.length === 0 ? 1 : Math.max(...numbers) + 1;
  return `LINHA-${String(next).padStart(3, "0")}`;
}
